import { cardsData } from '@/mocks/homeData';

const cardImages = [
  'https://readdy.ai/api/search-image?query=Fantasy%20manga%20cover%20art%20with%20a%20young%20adventurer%20silhouette%20against%20a%20starry%20galaxy%20backdrop%2C%20warm%20coral%20and%20deep%20space%20blue%20contrast%2C%20Japanese%20manga%20cover%20aesthetic%2C%20dramatic%20lighting%2C%20clean%20simple%20background&width=600&height=800&seq=card-manga-01&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Mystery%20manga%20cover%20style%20with%20detective%20silhouette%20in%20urban%20night%20setting%2C%20warm%20amber%20streetlights%20and%20dark%20shadows%2C%20noir%20atmosphere%2C%20clean%20composition%2C%20Japanese%20comic%20magazine%20cover%20aesthetic&width=600&height=800&seq=card-manga-02&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Romance%20manga%20cover%20art%20with%20soft%20pink%20and%20peach%20color%20palette%2C%20couple%20silhouettes%20under%20cherry%20blossoms%2C%20dreamy%20atmosphere%2C%20shojo%20manga%20aesthetic%2C%20clean%20minimal%20background&width=600&height=800&seq=card-manga-03&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20painting%20style%20manga%20cover%20with%20ancient%20swordsman%20and%20elegant%20lady%2C%20traditional%20hanfu%20clothing%2C%20warm%20earth%20tones%2C%20artistic%20brushwork%2C%20clean%20composition&width=600&height=800&seq=card-manga-04&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Cyberpunk%20manga%20cover%20art%20with%20futuristic%20city%20skyline%20and%20dimensional%20rift%2C%20warm%20neon%20orange%20and%20teal%20contrast%2C%20sci-fi%20aesthetic%2C%20clean%20composition%2C%20dynamic%20angle&width=600&height=800&seq=card-manga-05&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Epic%20fantasy%20manga%20cover%20with%20sky%20castle%20and%20dragon%20rider%20silhouette%2C%20warm%20sunset%20clouds%2C%20heroic%20atmosphere%2C%20adventure%20aesthetic%2C%20clean%20composition%2C%20Japanese%20shonen%20manga%20style&width=600&height=800&seq=card-manga-06&orientation=portrait',
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground-950 mb-3">
            编辑推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            本期精选优质漫画，每一部都值得细细品读
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardsData.map((item, i) => (
            <div
              key={i}
              className="group rounded-xl bg-background-50 border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative aspect-[3/4] bg-background-200 overflow-hidden">
                <img
                  src={cardImages[i]}
                  alt={item.cover}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-full text-[10px] md:text-xs font-medium bg-primary-500/90 text-background-50 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-3 bg-gradient-to-t from-black/70 via-black/40 to-transparent">
                  <span className="text-xs text-background-50/90 font-medium">{item.update}</span>
                </div>
              </div>

              <div className="p-4 md:p-5 flex flex-col gap-2 flex-1">
                <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2 flex-1">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}